export default __webpack_public_path__ + "static/media/banner-img.271c91b7.png";